export default __webpack_public_path__ + "static/media/WORLD_LANGUAGE.2384ccb1.svg";